import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('sellers', options)



// WEBPACK FOOTER //
// ./src/store/modules/sellers.store.js